import { Home, Map, FileText, Settings, MapPin, Bell } from 'lucide-react';
import type { Permission } from '@/schemas/auth/auth.schemas';

export interface NavItem {
  to: string;
  icon: typeof Home;
  labelKey: string;
  /** Single permission, or a list where any one grants visibility. */
  permission?: Permission | Permission[];
}

// Flat list — 6 items no longer warrant the old 4-group split (Cycles moved to
// the Settings hub, see DEV2-1133). Order per DEV2-1132's brief.
export const navItems: NavItem[] = [
  { to: '/', icon: Home, labelKey: 'navigation.dashboard', permission: 'view:dashboard' },
  { to: '/tracking', icon: Map, labelKey: 'navigation.tracking', permission: 'view:tracking' },
  {
    to: '/location-analytics',
    icon: MapPin,
    labelKey: 'navigation.location_analytics',
    permission: 'view:location-analytics',
  },
  { to: '/reports', icon: FileText, labelKey: 'navigation.reports', permission: 'view:reports' },
  { to: '/alerts', icon: Bell, labelKey: 'navigation.alerts', permission: 'view:reports' },
  {
    to: '/settings',
    icon: Settings,
    labelKey: 'navigation.settings',
    permission: 'view:settings',
  },
];
